import { createContext } from "react";

export const HelpTipContext = createContext({
  helpTipsList: [],
  isFetching: false,
});
